<template>
  <el-dialog
    :title="model.id ? '编辑成品组件' : '添加成品组件'"
    :visible.sync="visible"
    width="600px"
    @close="$emit('update:show', false)"
    :close-on-click-modal="false"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="110px"
      size="small"
    >
      <el-form-item label="组件名称" prop="name">
        <el-input v-model.trim="model.name"></el-input>
      </el-form-item>
      <el-form-item label="组件属性" v-if="visible">
        <TemplateFieldSelect
          :id="model.product_template_id"
          :category="1"
          :val="model.export_fields.t0"
          @change="handleFieldChange($event, 't0')"
        ></TemplateFieldSelect>
      </el-form-item>
      <el-form-item label="包含配件" prop="item_ids">
        <Item-select
          v-model="model.item_template_ids"
          :category="model.category"
          :product-template-id="model.product_template_id"
          :multiple="true"
        ></Item-select>
      </el-form-item>
      <el-form-item label="配件属性" v-if="visible">
        <div v-for="id in model.item_template_ids" :key="id">
          <TemplateFieldSelect
            :id="id"
            :category="2"
            :val="model.export_fields[`t${id}`]"
            class="m-b-10"
            @change="handleFieldChange($event, `t${id}`)"
          ></TemplateFieldSelect>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import {
  productComponentTemplateNew,
  productComponentTemplateUpdate,
} from '@/service/getData'
import ItemSelect from '@/components/select/item_template_multiple_select'
import TemplateFieldSelect from './TemplateFieldSelect'

export default {
  components: {
    ItemSelect,
    TemplateFieldSelect,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      rules: {
        name: [{ required: true, message: '请填写组件名称' }],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let data = this.model

          let fields = { t0: data.export_fields.t0 || [] }
          data.item_template_ids.map((id) => {
            fields[`t${id}`] = data.export_fields[`t${id}`] || []
          })

          data.export_fields = fields
          if (this.model.id > 0) {
            let res = await productComponentTemplateUpdate(data)
            if (res.status == 0) {
              this.$emit('edit', res.data)
              this.visible = false
            }
          } else {
            let res = await productComponentTemplateNew(data)
            if (res.status == 0) {
              this.$emit('edit', res.data)
              this.visible = false
            }
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    handleFieldChange(v, k) {
      this.model.export_fields[k] = v
    },
  },
}
</script>